import type { TestType } from '@prisma/client';
import { useAtomValue } from 'jotai';
import { useEffect, useState } from 'react';
import { activeStepAtom, selectedOperationIdAtom } from '~/atoms/no-code-atoms';
import { useLiveStateManager } from '~/hooks/useLiveStateManager';
import Browser from '../browser/Browser';
import { EmptyView } from '../browser/EmptyView';
import { IdleView } from '../browser/IdleView';
import ImageView from '../browser/implementations/ImageView';
import WebRtcVmView from '../browser/implementations/WebRtcVmView';
import { TOUR_ID } from '../tours/DraftEditorTour';

export default function BrowserPanel({
  className,
  testContentId,
  testType = 'WEB',
}: {
  className?: string;
  testContentId: string;
  testType?: TestType;
}) {
  const activeStep = useAtomValue(activeStepAtom);
  const selectedOperationId = useAtomValue(selectedOperationIdAtom);
  const { recorderInitiator } = useLiveStateManager();
  const [view, setView] = useState('live');

  useEffect(() => {
    if (recorderInitiator) {
      setView('live');
      return;
    }

    if (selectedOperationId || activeStep) {
      setView('snapshots');
    }
  }, [activeStep, recorderInitiator, selectedOperationId]);

  return (
    <div
      id={TOUR_ID.BROWSER_PANEL}
      className={`${className} w-full overflow-hidden`}
    >
      {view === 'live' ?
        recorderInitiator ?
          <WebRtcVmView
            testContentId={testContentId}
            recorderInitiator={recorderInitiator}
            testType={testType}
          />
        : <Browser testType={testType}>
            <IdleView testType={testType} />
          </Browser>

      : <Browser testType={testType}>
          {/* TODO: the data should retrieve screenshot for the operation  */}
          {selectedOperationId ?
            <ImageView key={selectedOperationId} />
          : <EmptyView />}
        </Browser>
      }
    </div>
  );
}
